module.exports = __webpack_public_path__ + "static/Infographic4_1_Taipei_mobile-99b8a821027cb27a0f110b1911475e2e.png";